
import { Injectable } from '@angular/core';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import {RoutingActions} from '../actions';
import { MessageActions} from '../actions/message.actions';


@Injectable()
export class MessageEffect {
	constructor(
		private updates$: Actions,
		private messageActions: MessageActions
	) { }

	@Effect() clearMessagesOnRouteChange$ = this.updates$
		.ofType(RoutingActions.ROUTING_EVENT_START)
		.mapTo(this.messageActions.clearMessages())
}





// WEBPACK FOOTER //
// ./src/app/effects/message.effect.ts